import './antSelect.less';

import React from 'react';
import { observer } from 'mobx-react';
import { Select, Tag } from 'antd';
import b_ from 'b_';
import { BaseOptionType, DefaultOptionType } from '@rc-component/select/lib/Select';
import classnames from 'classnames';

import { AntSelectProps, AntSelectValue, IdObject } from 'controls/react/ant/ant-select/types';
import { useSortedValues } from 'controls/react/ant/ant-select/hooks/useSortedValues';
import { useSortedOptions } from 'controls/react/ant/ant-select/hooks/useSortedOptions';
import { useChipsRender } from 'controls/react/ant/ant-select/hooks/useChipsRender';
import { useEditableTagRender } from 'controls/react/ant/ant-select/hooks/useEditableTagRender';
import { useReorderableMultiselect } from 'controls/react/ant/ant-select/hooks/useReorderableMultiselect';
import { useCloseOnMouseLeave } from 'controls/react/ant/ant-select/hooks/useCloseOnMouseLeave';
import { useTagsOptionRenderer } from 'controls/react/ant/ant-select/hooks/useTagsOptionRenderer';
import { useCustomDefaults } from 'controls/react/ant/ant-select/hooks/useCustomDefaults';
import { useObjectValue } from 'controls/react/ant/ant-select/hooks/useObjectValue';
import { useCustomWidth } from 'controls/react/ant/ant-select/hooks/useCustomWidth';
import { useOnVisibilityChangeToTriggerOnChange } from 'controls/react/ant/ant-select/hooks/useOnVisibilityChangeToTriggerOnChange';

export const AntTag = Tag;

const b = b_.with('ceeview-ant-select');

export const AntSelect = observer(
	<
		VT extends AntSelectValue,
		VTObj extends IdObject = { id: string },
		OptionType extends BaseOptionType = DefaultOptionType,
	>(
		propsWithObjectValue: AntSelectProps<VT, VTObj, OptionType>,
	) => {
		let props = useObjectValue<VT, VTObj, OptionType, typeof propsWithObjectValue>(propsWithObjectValue);

		props = useTagsOptionRenderer(props);
		props = useCustomDefaults(props);
		props = useSortedOptions(props);
		props = useSortedValues(props);
		props = useOnVisibilityChangeToTriggerOnChange(props);
		props = useEditableTagRender(props);
		props = useChipsRender(props);
		props = useCloseOnMouseLeave(props);
		props = useCustomWidth(props);
		props = useReorderableMultiselect(props);

		delete props.invalid;

		const { wrapper, className: initialClassName, componentRef, ...restProps } = props;

		const className = classnames(
			initialClassName,
			b({
				layout: restProps.layout,
			}),
		);

		const select = (
			<Select className={className} {...restProps} ref={componentRef}>
				{props.children}
			</Select>
		);

		return wrapper(select);
	},
);
